import React, { useState } from 'react'
import OrderContext from './OrderContext'

const OrderProvider = ({ children }) => {
    const [order, SetOrder] = useState([])
    return (
        <OrderContext.Provider value={{ order, SetOrder }}>
            {children}
        </OrderContext.Provider>
    )
}

export default OrderProvider